module.exports = __webpack_public_path__ + "img/shipping_type_2.3a835c5.png";